import React from "react";
import AjaxContentContainer from "./AjaxContentContainer";

// eslint-disable-next-line require-await
export default async (domNode, rehydrateChildren) => {
  const children = await rehydrateChildren(domNode);

  return <AjaxContentContainer>{children}</AjaxContentContainer>;
};
